import { DomainNamesDateRangeFilter } from './@component/DomainNamesDateRangeFilter';

export const RequestedDateFilter = () => {
  return (
    <DomainNamesDateRangeFilter
      startDateKey="requested_date_start"
      endDateKey="requested_date_end"
      label="Requested date"
      logType="requested date"
    />
  );
};
